import React, { Component } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Button, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import ProductCartItem from "../../customComponents/productCartItem/productCartItem";
import { ArrowRightAlt } from "@mui/icons-material";
import { Cart, CartItem } from "../../../classes/types/cart/cart";
import { CartHandler } from "../../../classes/methods/cartMethods/cartMethods";
import { euroPrint } from "../../../classes/types/currencysettings";
import NotLoggedIn from '../../customComponents/notLoggedIn/NotLoggedIn';
import CartEvents from "../../../classes/events/CartEvents";
import LoginEvent from "../../../classes/events/LoginEvent";
import LaterListEvents from "../../../classes/events/LaterListEvents";

interface State {
  cart: Cart;
  loading: boolean;
  unauthorized: boolean;
}

class CartView extends Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {
      cart: new Cart(),
      loading: false,
      unauthorized: false,
    }
  }

  componentDidMount() {
    this.refreshData();
  }

  refreshData = () => {
    this.setState({ loading: true });
    CartHandler.getCart().then((newCart) => {
      newCart.items.forEach(item => item.addons.sort((a,b) => a.sequence - b.sequence));
      this.setState({ cart: newCart, loading: false });
    }).catch(() => {
      CartEvents.callCartModifiedEvents();
      LaterListEvents.callLaterListModifiedEvents();
      LoginEvent.callLoginEvents();
      this.setState({ loading: false, unauthorized: true });
    });
  }

  render() {
    return (
      <div style={{paddingLeft: "50px", paddingRight: "50px", paddingBottom: '10%'}}>
        <div hidden={this.state.cart.items.length > 0 || this.state.loading || this.state.unauthorized}>
          <div style={{paddingTop: "5%",paddingBottom: "5%"}}>
            <Typography style={{marginBottom: "2%", fontWeight: "bold"}} variant="h3">Carrello</Typography>
            <Typography style={{marginBottom: "2%"}} variant="h4">Il tuo carrello è vuoto</Typography>
            <Link to={'/shop'}><Button variant="contained" color="primary">Sfoglia il catalogo</Button></Link>
          </div>
        </div>
        <div hidden={!this.state.unauthorized}><NotLoggedIn /></div>
        <div style={{marginTop:'2%'}} hidden={!this.state.loading}><CircularProgress /></div>
        <div hidden={this.state.loading || this.state.unauthorized || this.state.cart.items.length <= 0}>
          <Grid container>
            <Grid md={12} lg={8} item>
              <h1 style={{textAlign: "left", marginTop: "2%", marginBottom: "2%", fontSize: "25px"}}>Carrello</h1>
              <Divider variant="middle" style={{marginBottom: '1%'}}/>
              {this.state.cart.items.map((cartItem: CartItem) => (
                <div key={cartItem.id}>
                  <ProductCartItem
                    items={this.state.cart.items}
                    onQuantityChange={this.onCartItemQuantityChange}
                    onRemoveProductCallback={this.handleRemoveItemFromCart}
                    cartItem={cartItem}
                  />
                  {cartItem.isOutOfStock && (
                    <Typography style={{color: 'red', marginBottom: '1%'}}>
                      Attenzione: uno o più articoli di questo prodotto sono esauriti. La consegna sarà effettuata dopo 48/72h.
                    </Typography>
                  )}
                  <Divider variant="middle" style={{marginBottom: '1%'}}/>
                </div>
              ))}
            </Grid>
            <Grid md={12} sm={12} lg={4} justifyContent="center" alignItems="flex-start" item container>
              <div style={{width: '85%', marginTop: '13%', boxShadow: '3px 8px 15px 0.1px #ECECEC', textAlign: "left", padding: "5%" , borderRadius: "10px",border: "1px solid lightGrey" }}>
                <span style={{fontSize: "22px", fontWeight: "bold"}}>Riepilogo ordine</span><br/>
                <Divider style={{marginTop: "1%", marginBottom: "3%"}}/>
                <span style={{fontSize: "18px"}}>Articoli: <span style={{float: "right"}}>{euroPrint(this.state.cart.itemsTotal)}</span></span><br/>
                <span style={{fontSize: "18px"}}>Iva: <span style={{float: "right"}}>{euroPrint(this.state.cart.taxTotal)}</span></span><br/>
                <span style={{fontSize: "18px"}}>Spedizione: <span style={{float: "right"}}>{euroPrint(this.state.cart.shippingTotal)}</span></span><br/>
                <Divider style={{marginTop: "3%"}}/>
                <div style={{marginTop: "2%",fontSize: "20px"}} >
                  <span style={{fontSize: "24px"}}><b> Subtotale:  <span style={{float: "right"}}>{euroPrint(this.state.cart.total)}</span></b></span>
                </div>
                <span style={{fontSize: "18px"}}>Comprensivo di SIAE: <span style={{float: "right"}}>{euroPrint(this.calculateSIAETotal())}</span></span><br/>
                <Link to={'/cassa'}>
                  <Button style={{marginTop: "25px", padding: "3%", fontSize: "20px", width: "100%",whiteSpace: 'nowrap'}} endIcon={<ArrowRightAlt/>} variant="contained" color="primary">
                    Procedi al check-out
                  </Button>
                </Link>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }

  handleRemoveItemFromCart = (cartItemSelected: CartItem) => {
    if (cartItemSelected.id !== undefined) {
      CartHandler.deleteProductFromCart(cartItemSelected.id)
        .then(() => this.refreshData())
        .catch(() => {});
    }
  }

  calculateSIAETotal = () => {
    return this.state.cart.items.reduce((acc, item) => acc + item.product.taxSIAE * item.quantity, 0);
  }

  onCartItemQuantityChange = (cartItemSelected: CartItem) => {
    let cartCopy = { ...this.state.cart };
    const index = cartCopy.items.findIndex(item => item.id === cartItemSelected.id);
    if(index !== -1) cartCopy.items[index] = cartItemSelected;
    this.setState({ cart: cartCopy });
    CartHandler.UpdateCartItem(cartItemSelected).then(() => this.refreshData()).catch(console.log);
  }
}

// Rimosso withRouter perché non serve più in React Router v6
export default CartView;
